module.exports = __webpack_public_path__ + "static/media/header-4.a22df10e.png";